(function() {
    'use strict';

    angular
        .module('app.empresasFumigadoras')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/empresasFumigadoras',
                config: {
                    templateUrl: 'app/empresasFumigadoras/list.html',
                    controller: 'empresasFumigadoras.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-empresa-fumigadora/:id?',
                config: {
                    templateUrl: 'app/empresasFumigadoras/edit.html',
                    controller: 'empresasFumigadoras.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            },
            {
                url: '/editar-empresa-fumigadora-piloto/:empresaFumigadora?/:id?',
                config: {
                    templateUrl: 'app/empresasFumigadoras/edit-piloto.html',
                    controller: 'empresasFumigadoras.EditPiloto',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
